import { auth } from '../firebase';

export const API_BASE = (process.env.REACT_APP_DATAFIE_BASE_URL || 'https://your-api-domain.com').replace(/\/$/, '');

async function getIdToken() {
  if (!auth || !auth.currentUser) return null;
  return auth.currentUser.getIdToken();
}

export async function fetchWithAuth(path, options = {}) {
  const url = `${API_BASE}/${String(path).replace(/^\//, '')}`;
  const token = await getIdToken();

  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
  };

  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(url, { ...options, headers });
  const ct = res.headers.get('content-type') || '';
  const text = await res.text();

  if (!res.ok) {
    const err = new Error(`Request failed: ${res.status} - content-type=${ct} - body=${String(text).slice(0,400)}`);
    err.status = res.status;
    err.contentType = ct;
    err.body = text;
    throw err;
  }

  if (ct.includes('application/json')) {
    try {
      return JSON.parse(text);
    } catch (e) {
      const err = new Error(`Invalid JSON response from ${url} - content-type=${ct} - body=${String(text).slice(0,400)}`);
      err.contentType = ct;
      err.body = text;
      throw err;
    }
  }

  // non-JSON but successful: return raw text so caller can inspect
  return text;
}

// Example usage:
// import { fetchWithAuth } from 'src/utils/api';
// const result = await fetchWithAuth('/api/endpoint', { method: 'POST', body: JSON.stringify(payload) });
